import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'
import { Card, CardContent, Grid } from '@mui/material';

import { useFetchInitPaymentReception } from './hooks'
import { TablePaymentReception } from './TablePaymentReception'
import { FormPaymentReception } from './FormPaymentReception'

export const PaymentReception = () => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFetchInitPaymentReception({location, paramsURL})

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        // Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    // ------------------------------------------------ globalStates
    const { showForm } = globalStates
    // ------------------------------------------------ Helpers
    // ------------------------------------------------ Formularios
    // ------------------------------------------------ FetchData
    // ------------------------------------------------ Actions

    return (
        <AllowedAccess permissions={['224_PREDIO_JUDICIAL']} renderAuthFailed={<p>Error</p>}>
            {(!showForm) && (
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Card style={{zIndex:'1'}}>
                            <CardContent>
                                <div className='h4 mt-1 mb-1'> Predio Judicial: Boletas Bancarias</div>
                                <div className="border-bottom border-dark"></div>
                                <div className="pt-4"></div>
                                <TablePaymentReception useFetchInit={useFetchInit} />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            )}
            {(showForm) && (
                <FormPaymentReception useFetchInit={useFetchInit} />
            )}
        </AllowedAccess>
    )
}
